import { ActivityTypeEnum, MasterActivityTypeFlag } from "src/app/shared/constants/activity-type.enum";

export class MasterActivityFlagOption {
    id: number;
    value: string;
    isSelected:boolean;
    constructor(_id: number, _value: string, _isSelected:boolean) {
        this.id = _id;
        this.value = _value;
       this.isSelected = _isSelected;
    }
}

export class MasterActivityFlagOptions {
    options: MasterActivityFlagOption[] = [];
    constructor() {
        for (let key in MasterActivityTypeFlag) {
            let masterActivityFlagId = Number(key);
            if (!isNaN(masterActivityFlagId)) {
                this.options.push(new MasterActivityFlagOption(masterActivityFlagId, MasterActivityTypeFlag[masterActivityFlagId], masterActivityFlagId === ActivityTypeEnum.Activity));
            }
        }
    }
}